import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';

export interface DevConsoleState {
  config: DevConsoleConfig;
  isDevConsoleModalOpen: boolean;
  logCount: number;
  logs: string[];
}

export interface DevConsoleConfig {
  logLimit: number;
}

export const initialDevConsoleState: DevConsoleState = {
  config: {
    // ログ上限
    logLimit: 1000,
  },
  isDevConsoleModalOpen: false,
  logCount: 0,
  logs: [],
};

export const DevConsoleReducer = reducerWithInitialState(initialDevConsoleState)
  .case(actions.devConsole.init, (_state: DevConsoleState) => {
    return { ...initialDevConsoleState, config: _state.config, isDevConsoleModalOpen: _state.isDevConsoleModalOpen };
  })
  // ログ上限など設定用
  .case(actions.devConsole.configure, (_state: DevConsoleState, payload: DevConsoleConfig) => {
    return { ..._state, config: payload };
  })
  .case(actions.devConsole.output, (_state: DevConsoleState, payload: string) => {
    // 出力されたログ数が上限を超えた場合、先頭のログを削除
    while (_state.logs.length >= _state.config.logLimit) {
      _state.logs.shift();
    }
    return {
      ..._state,
      logCount: _state.logs.length + 1,
      logs: [..._state.logs, payload],
    };
  })
  .case(actions.devConsole.devConsoleModalOpen, (_state: DevConsoleState) => {
    return {
      ..._state,
      isDevConsoleModalOpen: true,
    };
  })
  .case(actions.devConsole.devConsoleModalClose, (_state: DevConsoleState) => {
    return {
      ..._state,
      isDevConsoleModalOpen: false,
    };
  });
